import WalletApi from '../lib/api/Wallet'
import LogonApi from '../lib/api/Logon'

function getToken() {
  const logonApi = new LogonApi()
  return logonApi
    .getToken('?features=wallet')
    .then((response) => response.data)
    .catch(() => null)
}

function getCountVisitWallet(walletApi) {
  return walletApi
    .countVisit()
    .then((response) => response.data.data)
    .catch(() => null)
}

export default async function countVisitWallet() {
  // get token
  const token = await getToken()
  if (token === null || !token.token) return

  const walletApi = new WalletApi(token)
  // acount visit wallet
  await getCountVisitWallet(walletApi)

  return
}
